<template>
  <a v-if="href && href.length > 0" :class="badgeClass" :href="href" target="_blank">
    <font-awesome-icon :icon="actualIcon" />
    &nbsp;
    <slot>File</slot>&nbsp;
    <font-awesome-icon :icon="fileIcon" />
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    href: {
      default: "",
    },
    fileIcon: {
      default: () => ["fal", "paperclip"],
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-bordered-blue",
      icon: ["fal", "book-open"],
    };
  },

  computed: {
    actualIcon() {
      if (this.href && this.href.length > 0) {
        if (
          this.href.substr(-3) === "png" ||
          this.href.substr(-3) === "jpg" ||
          this.href.substr(-3) === "gif"
        ) {
          return ["fal", "image"];
        }
      }

      return this.icon;
    },

    actualColor() {
      if (this.href && this.href.length > 0) {
        if (
          this.href.substr(-3) === "png" ||
          this.href.substr(-3) === "jpg" ||
          this.href.substr(-3) === "gif"
        ) {
          return "badge-bordered-warning";
        }
      }

      return this.color;
    },

    badgeClass() {
      return `badge ${this.actualColor} ${this.size}`;
    },
  },
};
</script>
